import styled from 'styled-components';
import { hexToRGB, typography } from '@/styles/helpers';

export const ScVipUserCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 16px;
  align-items: center;
  & .title {
    text-transform: uppercase;
    ${typography.headline3mobile};
  }
  & .description {
    ${typography.body1bold};
    color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
    font-weight: 400;
    letter-spacing: 0;
  }
`;
